// Ready for use when the API is added
import config from 'config';
import { isoDate } from 'utils/LocalDateTimeHelper';

const LOAD = 'horse-racing/nonrunners/LOAD';
const LOAD_SUCCESS = 'horse-racing/nonrunners/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/nonrunners/LOAD_FAIL';

const initialState = {
  byDate: {}
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        meetings: action.result,
        loading: false,
        loaded: true,
        error: null
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isLoading(globalState) {
  return globalState.horseRacing.nonRunners
      && globalState.horseRacing.nonRunners.loading;
}

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: client => client.get(config.api.horseRacing.nonRunners, {params: {meetingDate: isoDate(), countryGroups: "UK,IRE"}})
  };
}

export function get(state) {
  return state.horseRacing.nonRunners;
}




// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/nonRunners.js